import React from 'react'
import LegalPage from './LegalPage'
import ContactForm from './ContactForm'

const Contact = () => {
    return (
        <>
            <LegalPage>
            <section className="newPrivacyPolicy">
                <div className="container">
                    <div>
                        <h2>Contact Us</h2>
                        <div className="box">
                            {/* <h4>1. Introduction</h4>  */}
                            <p>
                                Thank you for using Poultryfy, the premier app for all your poultry management needs, brought to
                                you by Protein Revolution Foods Private Limited. We value your feedback and are here to assist you with any questions or
                                concerns you may have.
                            </p>
                            <p>Customer Support: If you need assistance with the app or have any questions, please reach out to
                                our customer support team:</p>
                            <ul>
                                <li> Email: contact@poultryfy.com</li>
                                <li>
                                    Phone: 7988079881
                                </li>
                                <li>Live Chat: Available on the app from 9 AM to 6 PM (Monday to Saturday) </li>

                            </ul>
                        </div>
                        <div className="box">
                            {/* <h4>2. Information We Collect</h4>  */}
                            <p>
                                Business Inquiries: For business-related inquiries, partnerships, or media requests, please contact us
                                at:
                            </p>
                            <ul>
                                <li> Email: contact@poultryfy.com</li>
                                <li>
                                    Phone: 7988079881
                                </li>
                            </ul>
                            <p>
                                Address: Protein Revolution Foods Private Limited Headquarters Village khera khemawati Tehsil Safidon Distt Jind HR 126112
                            </p>
                            <p>
                                Follow Us: Stay updated with the latest news and updates from Poultryfy:
                            </p>
                            <ul>
                                <li>Facebook: <a href="https://www.facebook.com/Poultryfy" target='_blank' rel='noopener noreferrer'>facebook.com/poultryfy</a> </li>
                                <li>
                                    Twitter: <a href="https://x.com/poultryfy" target='_blank' rel='noopener noreferrer'>twitter.com/poultryfy</a>
                                </li>
                                <li> Instagram: <a href="https://www.instagram.com/poultryfy" target='_blank' rel='noopener noreferrer'>instagram.com/poultryfy</a> </li>
                            </ul>
                            <p>We look forward to hearing from you and thank you for being a part of the Poultryfy community!<br />
                                Best regards,<br /> The Poultryfy Team SProtein Revolution Foods Private Limited </p>
                        </div>

                    </div>
                </div>
            </section>
            <div className="legal-contact">
                <ContactForm />
            </div>
            </LegalPage>
        </>
    )
}

export default Contact
